import React from 'react'
import { GatsbyImage } from "gatsby-plugin-image"

const Image = (props) => {
  const {
    alt,
    height,
    image,
    objectFit,
    className,
    loading,
    width
  } = props

  return (
    <GatsbyImage
      alt={alt}
      image={image}
      objectFit={objectFit}
      className={className}
      style={{
        height: height ? height: 'auto',
        width: width ? width: 'auto'
      }}
      loading={loading}
    />
  )
}

Image.defaultProps = {
  loading: 'lazy',
  objectFit: 'cover'
}

export default Image
